/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sovereign_BrandingInputs */

const en_sovereign_branding = /** @type {(inputs: Sovereign_BrandingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sovereign Branding`)
};

const es_sovereign_branding = /** @type {(inputs: Sovereign_BrandingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Marca Sovereign`)
};

const fr_sovereign_branding = /** @type {(inputs: Sovereign_BrandingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Image de marque Sovereign`)
};

const de_sovereign_branding = /** @type {(inputs: Sovereign_BrandingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sovereign Branding`)
};

const ja_sovereign_branding = /** @type {(inputs: Sovereign_BrandingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sovereignブランディング`)
};

const zh_sovereign_branding = /** @type {(inputs: Sovereign_BrandingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sovereign 品牌定制`)
};

const ar_sovereign_branding = /** @type {(inputs: Sovereign_BrandingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`العلامة التجارية Sovereign`)
};

const id_sovereign_branding = /** @type {(inputs: Sovereign_BrandingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Branding Sovereign`)
};

const it_sovereign_branding = /** @type {(inputs: Sovereign_BrandingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Branding Sovereign`)
};

const ru_sovereign_branding = /** @type {(inputs: Sovereign_BrandingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Брендинг Sovereign`)
};

const pt_sovereign_branding = /** @type {(inputs: Sovereign_BrandingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Branding Sovereign`)
};

const ko_sovereign_branding = /** @type {(inputs: Sovereign_BrandingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sovereign 브랜딩`)
};

/**
* | output |
* | --- |
* | "Sovereign Branding" |
*
* @param {Sovereign_BrandingInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const sovereign_branding = /** @type {((inputs?: Sovereign_BrandingInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sovereign_BrandingInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_sovereign_branding(inputs)
	if (locale === "es") return es_sovereign_branding(inputs)
	if (locale === "fr") return fr_sovereign_branding(inputs)
	if (locale === "de") return de_sovereign_branding(inputs)
	if (locale === "ja") return ja_sovereign_branding(inputs)
	if (locale === "zh") return zh_sovereign_branding(inputs)
	if (locale === "ar") return ar_sovereign_branding(inputs)
	if (locale === "id") return id_sovereign_branding(inputs)
	if (locale === "it") return it_sovereign_branding(inputs)
	if (locale === "ru") return ru_sovereign_branding(inputs)
	if (locale === "pt") return pt_sovereign_branding(inputs)
	return ko_sovereign_branding(inputs)
});